type EntityURLResponse = {
  hostname: string;
  id: string;
  section: string;
  subsection: string;
};

export const getEntityFromURL = (url: string): EntityURLResponse => {
  const { pathname, hostname } = new URL(url);
  const paths = pathname.split('/').filter(Boolean);
  const lastPath = paths[paths.length - 1];
  const secondToLastPath = paths[paths.length - 2];

  let id = '';
  const matchId = lastPath.match(/[a-z]?\d+(.html?)?$/);
  if (matchId) {
    id = matchId[0].replace(/\.html?$/, '');
  }

  return {
    hostname,
    id,
    section: paths[0],
    subsection: secondToLastPath,
  };
};
